function openkbtab(evt, kbtabName, sectionId) {
    var section = document.getElementById(sectionId);
    if (!section) return;

    var kbtabcontent = section.getElementsByClassName("kbtab-content");
    for (var i = 0; i < kbtabcontent.length; i++) {
        kbtabcontent[i].style.display = "none";
    }

    var kbtablinks = section.getElementsByClassName("kbtablinks");
    for (var i = 0; i < kbtablinks.length; i++) {
        kbtablinks[i].classList.remove("active");
    }

    var tabToShow = document.getElementById(kbtabName);
    if (tabToShow) {
        tabToShow.style.display = "block";
    }
    evt.currentTarget.classList.add("active");

    var container = section.querySelector('.kbtab');
    if (container) {
        var scrollToElement = evt.currentTarget;
        var scrollPosition = scrollToElement.offsetLeft - (container.offsetWidth - scrollToElement.offsetWidth) / 2;
        container.scrollLeft = scrollPosition;
    }
}

document.addEventListener("DOMContentLoaded", function() {
    var containers = document.getElementsByClassName('kbtab-container');
    for (var i = 0; i < containers.length; i++) {
        var section = containers[i].parentNode;
        var firstTab = section.getElementsByClassName("kbtablinks")[0];
        if (firstTab) {
            firstTab.click();
        }
    }
});